import { css } from 'styled-components';

import ColorConstants from '../../constants/ColorConstants';

export const DefaultWidgetBorder = css`
    border-radius: 4px;
    border: 1px solid ${ColorConstants['regal-blue-20%']};
`;
